// test1958
(1958 && 0);
